//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * @typedef {import("@/types/alert/alert")} AlertsTableOptions
 */
import { create } from "vue-modal-dialogs";

import { mapActions, mapGetters, mapState } from "vuex";
import { ALERT_STATUS, PANEL, ROLE } from "~/assets/js/constants";

import { isAllowedTo } from "~/assets/js/utils";
import CircleChart from "~/components/chart/CircleChart.vue";
import DoughnutChart from "~/components/chart/DoughnutChart.vue";
import PyramidChart from "~/components/chart/PyramidChart.vue";
import LineChart from "~/components/chart/line/LineChart.vue";
import MultiLineChart from "~/components/chart/line/MultiLineChart.vue";
import EmptyState from "~/components/includes/EmptyState.vue";
import ScrollbarWrapper from "~/components/scroll/ScrollbarWrapper";
import AlertsTransformer from "~/transformers/AlertsTransformer";
import InstancesTransformer from "~/transformers/InstancesTransformer";
import NewsItemsTransformer from "~/transformers/NewsItemsTransformer";

import ConfirmDialog from "~/components/modal/ConfirmDialog";

const confirm = create(ConfirmDialog);

export default {
  name: "DashboardIndex",
  components: {
    CircleChart,
    DoughnutChart,
    PyramidChart,
    ScrollbarWrapper,
    LineChart,
    MultiLineChart,
    EmptyState,
  },
  layout: "main",
  data() {
    return {
      PANEL,
      ROLE,
      isAllowedTo,
      instancesSearch: "",
      instancesPage: 0,
      instancesSortBy: "name",
      instancesOrderBy: "asc",
      isInstancesSorting: false,
      scrollProperties: {
        canScroll: {
          x: false,
          y: false,
        },
        dragging: false,
        positions: {
          left: 0,
          top: 0,
        },
      },
      redrawKey: 0,
    };
  },
  computed: {
    ...mapState("dashboard", [
      "newsItems",
      "alerts",
      "circles",
      "doughnuts",
      "loading",
      "pyramids",
      "computerEvolutionStats",
      "vaccineEvolutionStats",
      "alertEvolutionStats",
      "agencyEvolutionStats",
      "alertsPerDayEvolutionStats",
      "agentsPerDayEvolutionStats",
      "alertsPerVaccineEvolutionStats",
      "versionsPerAgentEvolutionStats",
      "isStatsEvolutionError",
    ]),
    ...mapState("application", ["version", "panel", "selectedAgency"]),
    ...mapState("instances", ["instances"]),
    ...mapGetters({
      isAdmin: "application/isAdmin",
      loggedRole: "application/getLoggedRole",
      loggedUser: "application/getLoggedUser",
      isSingleAgencyUser: "application/isSingleAgencyUser",
      mainInstanceType: "application/getMainInstanceType",
    }),
    evolutionComparisonOptions() {
      return [
        { key: this.$t("dashboard.charts.range.last7Days"), value: 7 },
        { key: this.$t("dashboard.charts.range.last30Days"), value: 30 },
      ];
    },
    evolutionOptions() {
      return [
        { key: this.$t("dashboard.charts.range.last7Days"), value: 7 },
        { key: this.$t("dashboard.charts.range.last30Days"), value: 30 },
        { key: this.$t("dashboard.charts.range.last365Days"), value: 365 },
      ];
    },
    doughnutsLength() {
      return this.doughnuts && this.doughnuts.length;
    },
    hasInstances() {
      return this.instances?.collection?.length > 0;
    },

    hasNewsItems() {
      return this.newsItems?.collection?.length > 0;
    },

    hasAlerts() {
      return this.alerts?.collection?.length > 0;
    },

    alertsTable() {
      /** @type{AlertsTableOptions} */
      const options = {
        role: this.loggedRole,
        i18n: this.$i18n,
        sortBy: this.sortBy,
        orderBy: this.orderBy,
        actionable: true,
        sortable: false,
        short: true,
      };
      return AlertsTransformer.table(this.alerts, options);
    },

    newsItemsTable() {
      const options = {
        role: this.loggedRole,
        i18n: this.$i18n,
        sortBy: this.sortBy,
        orderBy: this.orderBy,
      };
      return NewsItemsTransformer.latestNewsTable(this.newsItems, options);
    },

    instancesSort() {
      return {
        default: "ascendant",
        id: this.instancesSortBy,
        loading: this.isInstancesSorting,
        order: this.instancesOrderBy === "asc" ? "ascendant" : "descendant",
      };
    },

    instancesTable() {
      const options = {
        i18n: this.$i18n,
        sortBy: this.instancesSortBy,
        orderBy: this.instancesOrderBy,
      };
      return InstancesTransformer.table(this.instances, options);
    },
  },
  created() {
    if (this.loggedRole === ROLE.CLASSIFIED) {
      this.$router.push(`/vaccines`);
    }
    if (this.isSingleAgencyUser) {
      this.addNavLink({
        id: this.loggedUser.agencies[0].id,
        name: this.loggedUser.agencies[0].name,
        instanceType: this.mainInstanceType,
        isSingleAgencyUser: true,
      });
    }
    this.fetch();
  },
  methods: {
    ...mapActions({
      fetch: "dashboard/fetch",
      updateComputerEvolutionStats: "dashboard/updateComputerEvolutionStats",
      updateVaccineEvolutionStats: "dashboard/updateVaccineEvolutionStats",
      updateAlertEvolutionStats: "dashboard/updateAlertEvolutionStats",
      updateAgencyEvolutionStats: "dashboard/updateAgencyEvolutionStats",
      updateAlertsPerDayEvolutionStats: "dashboard/updateAlertsPerDayEvolutionStats",
      updateAgentsPerDayEvolutionStats: "dashboard/updateAgentsPerDayEvolutionStats",
      updateAlertsPerVaccineEvolutionStats: "dashboard/updateAlertsPerVaccineEvolutionStats",
      setAlert: "dashboard/setAlert",
      setSelectedAgency: "application/setSelectedAgency",
      addNavLink: "application/addNavLink",
      setInstances: "instances/setInstances",
    }),

    async onAlertTableAction({ action, row: alertId }) {
      switch (action) {
        case "alert-resolve":
          this.onResolve(alertId);
          break;
        case "alert-reject":
          this.onReject(alertId);
          break;
        case "alert-open":
          this.onOpen(alertId);
          break;
      }
    },

    /**
     * @param {uuid4} id
     */
    async onResolve(id) {
      const { accepted: isConfirm } = await confirm({
        title: this.$t("alerts.modal.resolve.title"),
        content: this.$t("alerts.modal.resolve.content"),
        borderClass: "border-status-warning",
      });
      if (isConfirm) {
        await this.setAlert({ id, status: ALERT_STATUS.RESOLVED, route: this.$route });
      }
    },
    /**
     * @param {uuid4} id
     */
    async onReject(id) {
      const { accepted: isConfirm } = await confirm({
        title: this.$t("alerts.modal.reject.title"),
        content: this.$t("alerts.modal.reject.content"),
        borderClass: "border-status-warning",
      });

      if (isConfirm) {
        await this.setAlert({ id, status: ALERT_STATUS.REJECTED, route: this.$route });
      }
    },

    async onTableSort(e) {
      this.instancesSortBy = e.header;
      this.instancesOrderBy = this.instancesOrderBy === "asc" ? "desc" : "asc";

      this.isInstancesSorting = true;

      await this.setInstances({
        page: this.instancesPage,
        sortBy: this.instancesSortBy,
        orderBy: this.instancesOrderBy,
      });

      this.isInstancesSorting = false;
    },

    async onTablePage({ page }) {
      this.instancesPage = page;
      await this.setInstances({
        page,
        sortBy: this.instancesSortBy,
        orderBy: this.instancesSrderBy,
        filter: this.instancesSearch,
      });
    },
    onComputerEvolutionStatsHasChanged(e) {
      this.updateComputerEvolutionStats(e);
    },
    onVaccineEvolutionStatsHasChanged(e) {
      this.updateVaccineEvolutionStats(e);
    },
    onAlertEvolutionStatsHasChanged(e) {
      this.updateAlertEvolutionStats(e);
    },
    onAgencyEvolutionStatsHasChanged(e) {
      this.updateAgencyEvolutionStats(e);
    },
    onAlertsPerDayEvolutionStatsHasChanged(e) {
      this.updateAlertsPerDayEvolutionStats(e);
    },
    onAgentsPerDayEvolutionStatsHasChanged(e) {
      this.updateAgentsPerDayEvolutionStats(e);
    },
    onAlertsPerVaccineEvolutionStatsHasChanged(e) {
      this.updateAlertsPerVaccineEvolutionStats(e);
    },
  },
};
